import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Modal, Button, Input, Form, Row, Col, Alert } from "antd";

import { useIsAuthenticated } from "@azure/msal-react";
import HeaderFarms from "../../utils/header_farms";
import { requestToken } from "../../auth/AuthServices";
import API from "../../services";
import { setEpicorToken } from "../../auth/AuthEpicor";

const LoginEpicor = ({ visible, onClose }) => {
  let navigate = useNavigate();

  const isAuthenticated = useIsAuthenticated();
  const session = JSON.parse(localStorage.getItem("session_farms"));

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [selectedData, setSelectedData] = useState({
    username: session.employee_id,
    password: "",
  });

  const handleLogin = async () => {
    setLoading(true);

    const accessToken = await requestToken();
    if (!accessToken) {
      return console.warn("Access token tidak ditemukan.");
    }

    try {
      const payload = {
        username: selectedData.username,
        password: selectedData.password,
      };

      const results = await API.LoginEpicor(HeaderFarms(accessToken), payload);

      if (results?.AccessToken) {
        localStorage.setItem("epicor_token", results.AccessToken);

        setEpicorToken(results.AccessToken);
        onClose(results.AccessToken);
      } else {
        console.warn("Token tidak ada:", results);
      }
    } catch (error) {
      console.error("Login failed", error);

      if (
        error?.response?.status === 401 ||
        (error?.response?.status === 400 &&
          error?.response?.data?.error ===
            "Failed to fetch. Please try again later.")
      ) {
        setErrorMessage("Password Salah");
        setTimeout(() => setErrorMessage(null), 3000);
        return;
      }

      if (
        error?.response?.status === 429 &&
        error?.response?.data?.error?.message ===
          "Terlalu banyak percobaan. Silakan coba lagi dalam 15 menit."
      ) {
        setErrorMessage(
          "Password Salah, silahkan login kembali dalam 15 menit"
        );
        setTimeout(() => setErrorMessage(null), 3000);
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate("/home");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = await requestToken();
        if (!accessToken) {
          
          return;
        }
        setSelectedData({
          username: session.employee_id,
          password: "",
        });
      } catch (error) {
        console.error("❌ Gagal mengambil data:", error);
      }
    };

    fetchData();
  }, [isAuthenticated]);
  return (
    <>
      <div>
        <Modal
          size="lg"
          title="Login your Epicor Account"
          centered
          visible={visible}
          onCancel={onClose}
          closable={false}
          maskClosable={false}
          footer={null}
        >
          <Form layout="vertical">
            <Alert
              key={"info"}
              message={"You can change employee id username default if needed"}
              type="info"
              showIcon
              className="mb-3"
            />

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="username"
                  label="Username Epicor"
                  rules={[{ required: true, message: "Password is mandatory" }]}
                >
                  <Input
                    autoComplete="true"
                    placeholder="Username"
                    value={selectedData.username}
                    onChange={(e) =>
                      setSelectedData({
                        ...selectedData,
                        username: e.target.value,
                      })
                    }
                    prefix
                  />
                  {""}
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  name="password"
                  label="Password Epicor"
                  rules={[{ required: true, message: "Password is mandatory" }]}
                >
                  <Input.Password
                    autoComplete="true"
                    placeholder="Password"
                    value={selectedData.password}
                    autoFocus
                    onChange={(e) =>
                      setSelectedData({
                        ...selectedData,
                        password: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
              {errorMessage && (
                <Alert
                  key={errorMessage}
                  message={errorMessage}
                  type="warning"
                  showIcon
                  closable
                  onClose={() => setErrorMessage(null)}
                />
              )}
            </Row>

            <hr />

            <div className="d-flex justify-content-end">
              <Button
                id="btn-close-login"
                className="mx-2"
                onClick={handleClose}
              >
                Cancel
              </Button>

              <Button
                id="btn-login-epicor"
                type="primary"
                onClick={handleLogin}
                disabled={loading}
              >
                Login
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default LoginEpicor;
